import { BOX_PLUS_CHANNELS_GRID_ZONES } from '@statsbomb/kitbag-datavis';

export type ZoneEventPoint = { startX: number; startY: number };

export type ZoneEventCount = {
  id: number;
  count: number;
  ratio: number;
};

const parseZoneBounds = (points: string) => {
  const coords = points.split(' ').map(point => {
    const [x, y] = point.split(',').map(Number);
    return { x, y };
  });
  return {
    minX: Math.min(...coords.map(coord => coord.x)),
    maxX: Math.max(...coords.map(coord => coord.x)),
    minY: Math.min(...coords.map(coord => coord.y)),
    maxY: Math.max(...coords.map(coord => coord.y)),
  };
};

const ZONE_BOUNDS = BOX_PLUS_CHANNELS_GRID_ZONES.map(zone => ({ id: zone.id, bounds: parseZoneBounds(zone.points) }));
const PITCH_MAX_X = Math.max(...ZONE_BOUNDS.map(({ bounds }) => bounds.maxX));
const PITCH_MAX_Y = Math.max(...ZONE_BOUNDS.map(({ bounds }) => bounds.maxY));

const isWithin = (value: number, min: number, max: number, pitchMax: number) =>
  value >= min && (value < max || (max === pitchMax && value === max));

export const getZoneEventCounts = (events: ZoneEventPoint[]): ZoneEventCount[] => {
  const counts = new Map<number, number>(ZONE_BOUNDS.map(({ id }) => [id, 0]));

  for (const { startX, startY } of events) {
    const match = ZONE_BOUNDS.find(
      ({ bounds }) =>
        isWithin(startX, bounds.minX, bounds.maxX, PITCH_MAX_X) &&
        isWithin(startY, bounds.minY, bounds.maxY, PITCH_MAX_Y),
    );
    if (match) counts.set(match.id, (counts.get(match.id) ?? 0) + 1);
  }

  const maxCount = Math.max(...counts.values());

  return ZONE_BOUNDS.map(({ id }) => {
    const count = counts.get(id) ?? 0;
    return { id, count, ratio: maxCount === 0 ? 0 : count / maxCount };
  });
};
